import React from 'react'
import PropTypes from 'prop-types'
import { languageController } from '../../../controllers/language/languageController';

function Form({
  className,
  type,
  onSubmit,
  isDark,
  children,
  requiredFieldsHelperText,
  errorMessage,
  ...otherProps
}) {
  return (
    <form
      className={[
        'mz-form',
        type ? `mz-form--${type}` : '',
        className,
        isDark ? 'mz-form--bg-dark' : '',
      ].join(' ')}
      onSubmit={onSubmit}
      {...otherProps}
    >
      {errorMessage && <p className={`caption ${isDark ? 'text--white' : 'text--red'}`}>{errorMessage}</p>}
      {requiredFieldsHelperText && <p className="mz-form__helper-text caption text--grey">* {languageController.getCopy('global', 'requiredFields')}</p>}
      {children}
    </form>
  )
}

Form.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  isDark: PropTypes.bool,
  requiredFieldsHelperText: PropTypes.bool,
};

Form.defaultProps = {
  className: '',
  isDark: false,
  requiredFieldsHelperText: false
}


export default Form
